import { render, staticRenderFns } from "./colorTemplate.vue?vue&type=template&id=e883972a&scoped=true&"
import script from "./colorTemplate.vue?vue&type=script&lang=js&"
export * from "./colorTemplate.vue?vue&type=script&lang=js&"
import style0 from "./colorTemplate.vue?vue&type=style&index=0&id=e883972a&prod&lang=scss&scoped=true&"
import style1 from "./colorTemplate.vue?vue&type=style&index=1&id=e883972a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e883972a",
  null
  
)

export default component.exports